import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { MutateFactDTO } from "../../dto";

type CreateFactProps = {
  poetryId: number;
  title: string;
  description: string;
};

let body: MutateFactDTO;

export async function createFactAction(props: CreateFactProps) {
  const token = localStorage.getItem("token");

  const params = {
    poetryId: props.poetryId,
    description: props.description,
    title: props.title,
  };

  return await axios
    .post(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/facts/create`,
      params,
      {
        headers: {
          "Content-Type": "application/json",
          "app-platform": "cms",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(async (res) => {
      body = plainToClass(MutateFactDTO, res.data);
      await validate(body);
      const errors = await validate(body);
      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
